<div class="row m-0 w-100 px-1">
  <div *ngFor="let kpi of kpiConfigs; first as isFirst; last as isLast; let indexValue = index"
    [ngClass]="{'p-left-0': isFirst,'p-right-0': isLast}" class="col px-2 pb-3 font-size-14" style="height:85px;">
    <div class="{{'d-flex flex-row card border-1 h-100 shadow-sm kpi_info_'+ indexValue}}">
      <div class="card-body p-0 ps-4 pe-4 bg-white">
        <div class="row h-100">
          <div class="d-flex flex-row align-items-center col-12 col-md-12 col-sm-4 pe-0 kpi_card_wrapper">
            <span *ngIf="kpi.value || kpi.value == 0"
              class="text-black-50 kpi-text font-size-22 fw-bolder kpi-padding"
              title="{{shortenLargeNumber(kpi.value, 1)}}">
              {{shortenLargeNumber(kpi.value, 1)}}
            </span>
            <span *ngIf="!kpi.value && kpi.value != 0" class="text-center ps-2 kpi-padding">
              <div class="spinner-border spinnerCls" role="status">
              </div>
            </span>
            <span class="text-black-50 kpi-text font-size-12 pe-1">{{kpi.title}}</span>
            <div *ngIf="kpi.popoverConfig">
              <si-info-popover [config]="kpi.popoverConfig"></si-info-popover>
              <div id="{{('popover_content_kpi_info_icon_' + indexValue)}}" class="npa-custom-popover-content" style="display:none">
                <div class="popover-content-wrapper" style="width: 400px;">
                  {{kpi.popoverContent}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
